import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AuthModal from './components/AuthModal';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HeroSection from './components/sections/HeroSection';
import ContentLibrarySection from './components/sections/ContentLibrarySection';
import HowItWorksSection from './components/sections/HowItWorksSection';
import ComparisonSection from './components/sections/ComparisonSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import FAQSection from './components/sections/FAQSection';
import CTASection from './components/sections/CTASection';
import ThankYouPage from './components/pages/ThankYouPage';
import ThemePagesPage from './components/pages/ThemePagesPage';
import PricingPage from './components/pages/PricingPage';
import DashboardPage from './components/pages/DashboardPage';
import PrivacyPolicyPage from './components/pages/PrivacyPolicyPage';
import DataDeletionPage from './components/pages/DataDeletionPage';
import TermsOfServicePage from './components/pages/TermsOfServicePage';
import BlogPage from './components/pages/BlogPage';
import BlogPostPage from './components/pages/BlogPostPage';
import BlogAdminPage from './components/pages/BlogAdminPage';
import AdminPanelPage from './components/pages/AdminPanelPage';
import AppPromoPage from './components/pages/AppPromoPage';

// Landing page with bulk scheduling service
const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <HowItWorksSection />
        <ContentLibrarySection />
        <ComparisonSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <AuthModal />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/app" element={<AppPromoPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/themepages" element={<ThemePagesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/admin" element={<AdminPanelPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/data-deletion" element={<DataDeletionPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/blog-admin" element={<BlogAdminPage />} />
            <Route path="/admin-panel" element={<AdminPanelPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
